<form [formGroup]="frmGroup">
  <label *ngIf="fieldInfo.showLabel" [fieldInfo]="fieldInfo" acForLable>
    {{ fieldInfo.label
    }}<span class="required-star" *ngIf="fieldInfo.required && fieldInfo.label"
      >*</span
    >
  </label>
  <hcc-custom-validation [validations]="fieldInfo.validations">
    <input
      type="text"
      inputValidateRef
      [value]="value"
      [formControlName]="control"
      class="form-control"
      acInputText
      [control]="control"
      [fieldInfo]="fieldInfo"
      [readOnly]="InputConfig?.isDisabled"
    />
  </hcc-custom-validation>
</form>
